export default "__VITE_ASSET__fba75686__"